const FAVORITE_TOOLTIP_GUIDE_SEEN_KEY_PREFIX =
    "twioku:is-shown-favorite-guide-tooltip";

export const hasShownFavoriteGuideTooltip = (userId: string): boolean => {
    const storageKey = `${FAVORITE_TOOLTIP_GUIDE_SEEN_KEY_PREFIX}:${userId}`;
    try {
        return window.localStorage.getItem(storageKey) === "1";
    } catch (error) {
        console.warn("Failed to access localStorage for tooltip guide", error);
        return false;
    }
};

export const markFavoriteGuideTooltipAsShown = (userId: string): void => {
    const storageKey = `${FAVORITE_TOOLTIP_GUIDE_SEEN_KEY_PREFIX}:${userId}`;
    try {
        window.localStorage.setItem(storageKey, "1");
    } catch (error) {
        console.warn("Failed to store favorite tooltip guide flag", error);
    }
};
